import Validatable from '@/validator/Validatable';

export enum UserSettingKeys {
  DISPLAY_NAME = 'display-name',
  LANGUAGE = 'language',
  NOTIFICATION_PREFERENCES = 'notification-preferences',
}

export interface IUserSetting {
  key: UserSettingKeys;
  value: string;
}

export interface IUserSettingApi {
  key: string;
  value: string;
}

export default class UserSetting extends Validatable {
  key: string;
  value: string;

  constructor(key: string, value: string) {
    super();
    this.key = key;
    this.value = value;
  }

  static fromApi(apiObject: IUserSettingApi): UserSetting {
    return new UserSetting(apiObject.key, apiObject.value);
  }

  toApi(): IUserSettingApi {
    return {
      key: this.key,
      value: this.value,
    };
  }

  static fromObject(obj: IUserSetting): UserSetting {
    return super.fromObject(obj, new UserSetting());
  }
}
